(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["3dorder-season-topic-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('season-topic-slider')) {
    customElements.define('season-topic-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        this.previousButton = this.querySelector('[data-slider-previous]');
        this.nextButton = this.querySelector('[data-slider-next]');

        if (!this.track || !this.previousButton || !this.nextButton) return;

        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });

        this.resizeObserver = new ResizeObserver(() => this.updateButtons());
        this.resizeObserver.observe(this.track);
        this.updateButtons();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      move(direction) {
        const distance = Math.max(this.track.clientWidth * .82, 220);
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: distance * direction, behavior: reducedMotion ? 'auto' : 'smooth' });
      }

      updateButtons() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        this.previousButton.disabled = this.track.scrollLeft <= 2;
        this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
